import { render } from "./BranchPieChart.vue?vue&type=template&id=6b3b41a4&scoped=true"
import script from "./BranchPieChart.vue?vue&type=script&lang=js"
export * from "./BranchPieChart.vue?vue&type=script&lang=js"

import "./BranchPieChart.vue?vue&type=style&index=0&id=6b3b41a4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3b41a4"]])

export default __exports__